import React, { useState } from "react";
import ConfigureSkills from "./ConfigureSkills";

const PositionDetail = (props) => {
  const [activeTab, setActiveTab] = useState(0); // Default active tab
  const tabsTitle = [
    {
      id: 1,
      title: "Configure Skills",
      component: (
        <ConfigureSkills positionAppliedId={props.positionAppliedId} />
      ),
    },
    {
      id: 2,
      title: "Interview Steps",
      component: "Tab2",
    },
    // Add more tabs as needed
  ];
  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  return (
    <div className="position-desc-sec">
      <div className="tab-section candidate-list-tab">
        {/* Tabs Button Start */}
        <div className="tab-header">
          {tabsTitle.map((tab, index) => (
            <button
              key={tab.id}
              className={activeTab === index ? "active" : ""}
              onClick={() => handleTabChange(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>
        {/* Tabs Button End */}

        {/* Active Tabs Component Start */}
        <div className="tab-content">
          {activeTab !== -1 && (
            <div className="tab-body-section">
              {tabsTitle[activeTab].component}
            </div>
          )}
        </div>
        {/* Active Tabs Component End */}
      </div>
    </div>
  );
};

export default PositionDetail;
